import InstructorSection from "./InstructorSection";
export default InstructorSection;
